import { createFileRoute } from '@tanstack/react-router';
import { RelatorioFiscalItensNotasFiscais } from '@/features/relatorio/page/fiscal/itens-notas-fiscais/RelatorioFiscalItensNotasFiscais';

export const Route = createFileRoute('/a/relatorio/fiscal/itens-notas-fiscais')({
    component: RelatorioFiscalItensNotasFiscais,
});
